<template>

  <t-page>


    <t-page-form multi-cards :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form.companyId" hidden/>

        <t-form-card title="Dados Básicos">

          <e-person :person="form.person" :command="command" not-required :error="error_person"
                    @getApi="getEmbedCNPJApi"
                    :status="status"/>

          <e-address :address="form.address" :command="command" not-required :status="status"
                     @getApi="getEmbedAddressApi"/>


          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status"/>

        </t-form-card>

        <t-form-card title="Dados de Contato">

          <b-row>

            <t-input v-model="form.companyRegistration" cols="3" class-icon-group="icon-mail-colored" label="Registro de Entidade">
              <template #input-icon>
                <b-icon-bag-check/>
              </template>
            </t-input>

            <t-input v-model="form.site" cols="3" class-icon-group="icon-mail-colored" url label="Site">
              <template #input-icon>
                <b-icon-link/>
              </template>
            </t-input>

            <t-input v-model="form.email" cols="3" class-icon-group="icon-mail-colored" email-multiple label="E-mail">
              <template #input-icon>
                <b-icon-envelope/>
              </template>
            </t-input>

            <t-input v-model="form.phone" cols="3" class-icon-group="icon-mail-colored" tel label="Telefone fixo">
              <template #input-icon>
                <b-icon-telephone/>
              </template>
            </t-input>


          </b-row>

          <b-row>

            <t-input v-model="form.whatsapp" cols="3" small="WhatsApp principal da empresa"
                     class-icon-group="icon-whatsapp-colored" tel label="WhatsApp">
              <template #input-icon>
                <b-icon-whatsapp/>
              </template>
            </t-input>

            <t-input v-model="form.instagram" small="Insira o link completo do seu perfil" cols="3"
                     class-icon-group="icon-mail-colored" label="Instagram">
              <template #input-icon>
                <b-icon-instagram/>
              </template>
            </t-input>

            <t-input v-model="form.youtube" small="Insira o link completo do seu canal" cols="3"
                     class-icon-group="icon-mail-colored"
                     label="Youtube">
              <template #input-icon>
                <b-icon-youtube/>
              </template>
            </t-input>

            <t-input v-model="form.linkedin" small="Insira o link completo do seu perfil" cols="3"
                     class-icon-group="icon-mail-colored" label="LinkedIn">
              <template #input-icon>
                <b-icon-linkedin/>
              </template>
            </t-input>

          </b-row>

        </t-form-card>

        <t-form-card title="Cabeçalho de Relatórios">

          <b-row>

            <b-col cols="6">

              <label>Cabeçalho - Primeira Página</label>
              <vue-editor
                  id="editor-sm1"
                  ref="editorComment"
                  class="editorSmall"
                  :editor-toolbar="customToolbar"
                  :disabled="status === 'sending'"
                  v-model="form.reportHeaderContentFirstPage">
              </vue-editor>

            </b-col>

            <b-col cols="6">

              <label>Cabeçalho - Demais Páginas</label>
              <vue-editor
                  id="editor-sm2"
                  ref="editorComment"
                  class="editorSmall"
                  :editor-toolbar="customToolbar"
                  :disabled="status === 'sending'"
                  v-model="form.reportHeaderContentOtherPage">
              </vue-editor>

            </b-col>

          </b-row>


        </t-form-card>



        <t-form-card title="Informações para Orçamentos">

          <b-row>

            <t-input cols="4" v-model="form.defaultInvoiceTax" percent
                     label="Impostos (%)"
                     help="Utilizado quando desejar indicar o percentual de impostos padrão por item no orçamento, quando utilizado irá inserir o percentual como padrão nos itens do orçamento, porém poderá ser alterado, sendo somente um percentual padrão."/>

            <t-input cols="4" v-model="form.defaultCompanyExpense" percent
                     label="Outros (%)"
                     help="Utilizado geralmente como Royalties, quando utilizado irá inserir o percentual como padrão nos itens do orçamento, porém poderá ser alterado, sendo somente um percentual padrão."/>


            <t-input cols="4" v-model="form.defaultOtherExpense" percent
                     label="Despesas Indiretas (BDI) (%)"
                     help="Utilizado geralmente como BDI ou lucro mínimo, quando utilizado irá inserir o percentual como padrão nos itens do orçamento, porém poderá ser alterado, sendo somente um percentual padrão."/>

          </b-row>

        </t-form-card>

        <t-form-card title="Integrações" v-if="isUpdate() || isView()">

            <t-button @click="showToken = !showToken" v-show="!showToken">Exibir Token de Integração</t-button>



          <div>

            <t-button  @click="copyToClipboard(form.token,'companyTokenInput')"  v-show="showToken">

              <b-icon-clipboard class="mr-2"></b-icon-clipboard>
              Copiar dados
            </t-button>


            <t-button class="ml-3" @click="changeToken()"  v-show="showToken">


              <b-icon-arrow-clockwise class="mr-2"></b-icon-arrow-clockwise>
              Substituir Token
            </t-button>


          </div>


            <t-input v-model="form.token" v-show="showToken" class="mt-2" textarea disabled
                     label="API Token"
                     iid="companyTokenInput"
                     help="Utilizado para integração Word / Api, entre outros."/>



        </t-form-card>


      </template>

    </t-page-form>

  </t-page>

</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ePerson from "@/views/embed/general/e-person";
import eAddress from "@/views/embed/general/e-address";
import http from "@/services/config/http-common";
import {VueEditor} from "vue2-editor";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  components: {ePerson, eAddress, VueEditor},
  name: 'CompanyForm',
  data() {
    return {
      path: "admin/company", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "companyId",
      form: {
        companyId: 0,
        companyNumber: 0,
        person: {
          /*Embed Person version: 1.0*/
          typePerson: 2,
          name: "",
          shortName: "",
          companyName: "",
          federalTaxpayer: "",
          otherPersonalDocument: "",
          provinceTaxpayer: "",
          provinceTaxpayerExempted: false,
          defaultInvoiceTax: 0.0,
          defaultCompanyExpense: 0.0,
          defaultOtherExpense: 0.0,
          cityTaxpayer: "",
          /*-------------------------*/
        },
        address: {
          /*Embed Address version: 1.0*/
          country: "BR",
          zipcode: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          provinceAbbreviation: "",
          cityId: 0
          /*-------------------------*/
        },
        site: "",
        email: "",
        phone: "",
        companyRegistration: "",
        whatsapp: "",
        linkedin: "",
        instagram: "",
        youtube: "",
        facebook: "",
        note: "",
        reportHeaderContentFirstPage: "",
        reportHeaderContentOtherPage: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
      },
      /*Embed Person Errors version: 1.0*/
      error_person: {
        name: "",
        federalTaxpayer: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      showToken:false,
      customToolbar: [
        ["bold", "italic", "underline"],
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {


    },
    async onSubmit() {

      this.form.reportHeaderContentFirstPage = ui.prepareHTML(this.form.reportHeaderContentFirstPage,500)
      this.form.reportHeaderContentOtherPage = ui.prepareHTML(this.form.reportHeaderContentOtherPage,500)

      await this.setSendingDefault()


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async changeToken(){

      await http.get(this.path + "/refresh-token/"+this.form.companyId).then(async (response) => {

        this.form.token = response.data.token

      }).catch(error => {
       this.responseError(error)
      })

    },
    //--------------------------------------------------------------------------------------


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
